export { SchoolAttachForm } from './school-attach-form';
